(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function init(root) {
    if (!root || root.getAttribute('data-mobile-gallery-ready') === 'true') return;

    var track = root.querySelector('.product-page--media-track');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.product-page--media-slide')) : [];
    var swipePrompt = root.querySelector('.product-page--swipe-prompt');
    var variantSelect = root.querySelector('#variant-listbox');
    var mapElement = document.querySelector('[data-product-media-variants="' + root.getAttribute('data-section-id') + '"]');
    if (!track || !variantSelect || !mapElement || !slides.length) return;

    var mediaVariants;
    try {
      mediaVariants = JSON.parse(mapElement.textContent);
    } catch (error) {
      return;
    }

    root.setAttribute('data-mobile-gallery-ready', 'true');
    var scrollTimer;
    var galleryIsFollowingVariant = false;
    var hasSwiped = false;
    var observedSlide;

    function activeSlide() {
      return slides.filter(function (slide) {
        var image = slide.querySelector('.product-page--image');
        return image && image.getAttribute('data-active') === 'true';
      })[0] || slides[0];
    }

    function slideLeft(slide) {
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      return track.scrollLeft + slideRect.left - trackRect.left;
    }

    function nearestSlide() {
      return slides.reduce(function (best, slide) {
        return Math.abs(slideLeft(slide) - track.scrollLeft) < Math.abs(slideLeft(best) - track.scrollLeft) ? slide : best;
      }, slides[0]);
    }

    function markActive(slide) {
      var mediaId = slide.getAttribute('data-media-id');
      root.querySelectorAll('.product-page--image, .product-page--thumb').forEach(function (element) {
        element.setAttribute('data-active', String(element.getAttribute('data-id') === mediaId));
      });
    }

    function unveilSlide(slide) {
      if (!slide) return;
      var image = slide.querySelector('.product-page--image img.lazyload');
      if (!image) return;
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(image);
      }
    }

    function resizeTrack(slide) {
      if (!mobileQuery.matches || !slide) {
        track.style.height = '';
        track.style.removeProperty('aspect-ratio');
        return;
      }

      // Flex tracks otherwise retain the height of their tallest media item,
      // leaving a large gap after moving from landscape video to a square image.
      var height = slide.getBoundingClientRect().height;
      if (height > 0) {
        track.style.height = Math.ceil(height) + 'px';
        track.style.aspectRatio = 'auto';
      }
      observedSlide = slide;
    }

    function scrollToMedia(mediaId, behavior) {
      var slide = track.querySelector('.product-page--media-slide[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      unveilSlide(slide);
      if (!mobileQuery.matches) return;
      galleryIsFollowingVariant = true;
      resizeTrack(slide);
      track.scrollTo({ left: slideLeft(slide), behavior: behavior });
      window.setTimeout(function () { galleryIsFollowingVariant = false; }, behavior === 'smooth' ? 550 : 0);
    }

    function variantForId(id) {
      return window.product_json && window.product_json.variants.filter(function (variant) {
        return String(variant.id) === String(id);
      })[0];
    }

    function chooseVariant(variant) {
      if (!variant || String(variant.id) === variantSelect.value) return;

      var optionSelectors = root.querySelectorAll('.selector-wrapper select');
      if (optionSelectors.length === variant.options.length && window.jQuery) {
        variant.options.forEach(function (value, index) {
          optionSelectors[index].value = value;
          window.jQuery(optionSelectors[index]).trigger('change');
        });
      } else {
        variantSelect.value = String(variant.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function syncVariantFromSlide(slide) {
      var candidates = mediaVariants[slide.getAttribute('data-media-id')] || [];
      var currentId = parseInt(variantSelect.value, 10);

      // Unassigned media does not affect selection. For shared media, retain a
      // valid current variant and never make an arbitrary choice.
      if (!candidates.length || candidates.indexOf(currentId) !== -1 || candidates.length !== 1) return;
      chooseVariant(variantForId(candidates[0]));
    }

    function settleSwipe() {
      if (!mobileQuery.matches || galleryIsFollowingVariant) return;
      var nearest = nearestSlide();
      var destination = slideLeft(nearest);

      // iOS can end momentum between snap points when a video player is one of
      // the flex items. Correct the final position before activating the media.
      if (Math.abs(destination - track.scrollLeft) > 1) {
        track.scrollTo({ left: destination, behavior: 'smooth' });
        return;
      }

      resizeTrack(nearest);
      markActive(nearest);
      syncVariantFromSlide(nearest);
    }

    track.addEventListener('scroll', function () {
      if (!mobileQuery.matches) return;
      if (!hasSwiped && Math.abs(track.scrollLeft - slideLeft(activeSlide())) > 8) {
        hasSwiped = true;
        root.setAttribute('data-gallery-interacted', 'true');
      }
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(settleSwipe, 100);
    }, { passive: true });
    track.addEventListener('scrollend', settleSwipe);

    track.addEventListener('keydown', function (event) {
      if (!mobileQuery.matches || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault();
      var index = slides.indexOf(activeSlide()) + (event.key === 'ArrowRight' ? 1 : -1);
      var next = slides[Math.max(0, Math.min(slides.length - 1, index))];
      unveilSlide(next);
      track.scrollTo({ left: slideLeft(next), behavior: 'smooth' });
    });

    track.addEventListener('pointerdown', function () {
      if (!mobileQuery.matches) return;
      var current = nearestSlide();
      var index = slides.indexOf(current);
      unveilSlide(slides[index - 1]);
      unveilSlide(slides[index + 1]);
    }, { passive: true });

    if (swipePrompt) {
      swipePrompt.addEventListener('click', function () {
        if (!mobileQuery.matches) return;
        var nearest = nearestSlide();
        var next = slides[(slides.indexOf(nearest) + 1) % slides.length];

        unveilSlide(next);
        hasSwiped = true;
        root.setAttribute('data-gallery-interacted', 'true');
        track.focus({ preventScroll: true });
        track.scrollTo({ left: slideLeft(next), behavior: 'smooth' });
      });
    }

    root.querySelectorAll('.product-page--thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToMedia(thumb.getAttribute('data-id'), 'smooth');
      });
    });

    variantSelect.addEventListener('change', function () {
      var variant = variantForId(variantSelect.value);
      var media = variant && (variant.featured_media || variant.featured_image);
      if (media) window.setTimeout(function () { scrollToMedia(media.id, 'smooth'); }, 0);
    });

    if (window.ResizeObserver) {
      var mediaResizeObserver = new ResizeObserver(function () {
        resizeTrack(observedSlide || activeSlide());
      });
      slides.forEach(function (slide) { mediaResizeObserver.observe(slide); });
    } else {
      window.addEventListener('resize', function () { resizeTrack(activeSlide()); });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () { resizeTrack(activeSlide()); });
    }

    scrollToMedia(activeSlide().getAttribute('data-media-id'), 'auto');
    window.requestAnimationFrame(function () {
      resizeTrack(activeSlide());
      root.setAttribute('data-gallery-measured', 'true');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.product-page--root').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
